import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserManagementState {
  userManagement: IUser[];
}

const initialState: UserManagementState = {
  userManagement: [],
};

export const userManagementSlice = createSlice({
  name: "userManagement",
  initialState,
  reducers: {
    setUserManagement: (
      state,
      { payload }: PayloadAction<UserManagementState["userManagement"]>
    ) => {
      state.userManagement = payload;
    },
    clearUserManagement: (state) => {
      state.userManagement = [];
    },
  },
});

export const { setUserManagement, clearUserManagement } =
  userManagementSlice.actions;
